import { useClient } from "../composables/useClient"
import { AppError, AppErrors, handleAppError } from "./error"
import { type ContentVersion, ContentVersionSchema } from "./types"

const fetchContentVersion = async (contentVersionId: string) => {
  const { GET } = useClient()

  try {
    const { data, error } = await GET("/api/content_versions/{id}", {
      params: {
        path: {
          id: contentVersionId
        }
      }
    })

    if (error) {
      throw new AppError(AppErrors.FetchContentVersionRequest)
    }
    const validation = ContentVersionSchema.safeParse(data)
    if (!validation.success) {
      console.log(validation.error.message)
      throw new AppError(AppErrors.FetchContentVersionResponse)
    }

    return validation.data
  } catch (error) {
    handleAppError(error, new AppError(AppErrors.FetchContentVersion))
    return null
  }
}

export const getContentVersion = async (
  contentVersionId: string
): Promise<ContentVersion | null> => {
  const contentStore = useContentStore()

  let contentVersion: ContentVersion | undefined =
    contentStore.versions[contentVersionId]

  if (!contentVersion) {
    const fetchedContentVersion = await fetchContentVersion(contentVersionId)
    const validation = ContentVersionSchema.safeParse(fetchedContentVersion)

    if (validation.success) {
      contentVersion = validation.data
      contentStore.setContentVersion(contentVersionId, contentVersion)
    } else {
      console.log(validation.error.message)
      throw new AppError(AppErrors.UseContentVersionInvalid)
    }
  }

  const validation = ContentVersionSchema.safeParse(contentVersion)

  if (!validation.success) {
    console.log(validation.error.message)
    throw new AppError(AppErrors.UseContentVersionInvalid)
  }

  return contentVersion
}
